import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Widget from "../../components/widget/Widget";
import Featured from "../../components/featured/Featured";
import Chart from "../../components/chart/Chart";
import Table from "../../components/table/Table";
import "./home.scss";

let count = [
  {
    type: "accredited",
  },
  {
    type: "user",
  },
  {
    type: "order",
  },
  {
    type: "earning",
  },
  {
    type: "balance",
  },
];

const Home = () => {
  return (
    <div className="home">
      <Sidebar />
      <div className="homeContainer">
        <Navbar />
        <div className="widgets">
          {count.map((value => (<Widget type={value.type} />)))}
          
        </div>
        <div className="charts">
          <Featured />
          <Chart title="Last 6 Months (Revenue)" aspect={2 / 2} />
        </div>
                  
      </div>
    </div>
  );
};

export default Home;
